<template>
  <van-dialog
    theme="round-button"
    class="serviceEnd-dialog"
    v-model="show"
    title="提示"
    :show-confirm-button="false"
    :show-cancel-button="false"
  >
    <div class="dialog-content">
      <div class="info">系统计算实际到达里程数为{{ arriveMileage }}公里，请确认是否有误差，如有误差请填写实际到达里程</div>
      <van-form
        ref="form"
        validate-first
        :show-error-message="false"
      >
        <van-field
          name="value"
          class="textarea-box"
          v-model="mileage"
          label="申诉到达里程"
          placeholder="请输入"
        >
          <template #button>
            <span>KM</span>
          </template>
        </van-field>
      </van-form>
      <van-button
        type="info"
        size="large"
        class="confirm"
        @click="confirm"
      >确认</van-button>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'ServiceEndDialog',
  props: {
    arriveMileage: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      show: false,
      mileage: ''
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    confirm() {
      if (this.mileage && !(/^([0]|[1-9][0-9]*)$/).test(this.mileage)) {
        this.$toast('请输入0或者正整数');
      } else {
        this.$emit('confirm', this.mileage);
      }
    },
    cancel() {
      this.close();
      this.mileage = '';
    }
  }
};
</script>

<style lang="scss" scoped>
.serviceEnd-dialog{
  .info{
    line-height: 25px;
    margin-bottom: 20px;
  }
  .dialog-content{
    padding: 20px;
    box-sizing: border-box;
  }
  .confirm{
    height: 40px;
    border-radius: 20px;
    margin-top: 20px;
  }
}

</style>
